const stripTrailingSlashes = (value = '') => value.replace(/\/+$/, '');

const ensureLeadingSlash = (value = '') => (value.startsWith('/') ? value : `/${value}`);

const resolveEnv = (value, fallback) => (value === undefined ? fallback : value);

const isDevelopment = process.env.NODE_ENV === 'development';

const defaultApiOrigin = isDevelopment ? '' : 'https://api.mega-hissotto.com';

export const API_ORIGIN = stripTrailingSlashes(
	resolveEnv(process.env.VUE_APP_API_ORIGIN, defaultApiOrigin)
);

export const API_PREFIX = stripTrailingSlashes(
	ensureLeadingSlash(resolveEnv(process.env.VUE_APP_API_PREFIX, '/api'))
);

const defaultStorageOrigin = isDevelopment ? '' : 'https://api.mega-hissotto.com';

export const STORAGE_ORIGIN = stripTrailingSlashes(
	resolveEnv(process.env.VUE_APP_STORAGE_ORIGIN, API_ORIGIN || defaultStorageOrigin)
);

export const API_BASE_URL = `${API_ORIGIN}${API_PREFIX}`;
export const STORAGE_BASE_URL = `${STORAGE_ORIGIN}/storage`;

export const buildApiUrl = (path = '') => {
	if (!path) return API_BASE_URL;
	if (/^https?:\/\//i.test(path)) return path;
	const normalizedPath = path.startsWith('/') ? path : `/${path}`;
	return `${API_BASE_URL}${normalizedPath}`;
};

export const buildStorageUrl = (path = '') => {
	if (!path) return '';
	if (/^https?:\/\//i.test(path)) return path;
	const normalizedPath = path.replace(/^\//, '').replace(/^public\//, '');
	return `${STORAGE_BASE_URL}/${normalizedPath}`;
};

